import { useEffect } from "react";
import { AnswersType, FlagsType, ParticipantExamQuestion } from "../../types/question";

export const useSaveAnswers = (
  questions: ParticipantExamQuestion[],
  setAnswers: (value: React.SetStateAction<AnswersType>) => void,
  setFlags: React.Dispatch<React.SetStateAction<FlagsType>>,
) => {
  useEffect(() => {
    const answers: AnswersType = {};
    const flags: FlagsType = {};

    if (questions.length <= 0) {
      return;
    }

    questions.forEach((question) => {
      if (question.is_flagged) {
        flags[question.id] = true;
      }

      if (!question?.selected_answer) {
        return;
      }

      answers[question.id] = question.selected_answer.answer_text;
    });

    setAnswers(answers);
    setFlags(flags);
  }, [questions, setAnswers, setFlags]);
};
